module.exports = __webpack_public_path__ + "img/fakeThree.f41fee5a.png";